import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useAccountProfileCreateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (params: { accountProfile: Api.AccountProfile; impersonationContext?: Api.IImpersonationContext }) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `accountProfile`,
					impersonationContext: params.impersonationContext,
				}),
				'POST',
				params.accountProfile
			);
		},
		onError,
		onSuccess,
	});
}
